// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__3KTqs","link":"Video_link__3tsVV","blackbox":"Video_blackbox__3Fr7g"};